import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("gestion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.gestion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_creacion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.razon_social + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.razon_social + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_aprobacion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_aprobacion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_ejecucion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.fecha_ejecucion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
       
            return cf.runFilters();
        },

        filterGestion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                gestion: val
            });
        },
        filterFechaCreacion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_creacion: val
            });
        },
        filterFechaAprobacion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_aprobacion: val
            });
        },
        filterFechaEjecucion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_ejecucion: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
     
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                gestion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_creacion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_aprobacion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_ejecucion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""
            });
           
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/incremento_salarial/mixins/filtros.js